export const filtros = {
    Processadores: ["TDP", "Marca", "Clock", "Cores", "Socket"],

    "Placas de Vídeo": [
        "Capacidade VRAM",
        "Tecnologia VRAM",
        "Marca",
        "Clock",
        "Tamanho",
        "Retail Name",
        "TDP",
    ],

    Coolers: ["Marca", "Fan AirFlow", "Socket", "Tipo"],

    "Placas-Mãe": [
        "Capacidade RAM",
        "Tecnologia RAM",
        "Marca",
        "Chipset",
        "Form Factor",
        "Socket",
    ],

    "Memórias RAM": ["Marca", "Capacidade", "Clock", "Tecnologia"],

    Fontes: ["Marca", "Certificação", "Modular", "Potencia"],

    Gabinetes: ["Marca", "Cor", "Dimensões", "Tamanho Maximo GPU", "Form Factor"],

    Armazenamentos: [
        "Marca",
        "Tipo de Conexão",
        "Geração PCI",
        "Tipo",
    ]
};

function cheapestStorePriceForProduct(product) {
    const cheapestStorePrice = product.stores.reduce((lowerPrice, store) => {
        const currentPrice = parseFloat(store.spot_price);
        if (currentPrice < lowerPrice) {
            return currentPrice;
        }

        return lowerPrice;
    }, Infinity);

    return cheapestStorePrice;
}

export const ordemCrescente = (produtosDisponiveis) => {
    produtosDisponiveis.sort(function (itemAProduct, itemBProduct) {
        const cheapestStorePriceA = cheapestStorePriceForProduct(itemAProduct);
        const cheapestStorePriceB = cheapestStorePriceForProduct(itemBProduct);

        return parseFloat(cheapestStorePriceA) - parseFloat(cheapestStorePriceB);
    });
};

export const ordemDecrescente = (produtosDisponiveis) => {
    produtosDisponiveis.sort(function (itemAProduct, itemBProduct) {
        const cheapestStorePriceA = cheapestStorePriceForProduct(itemAProduct);
        const cheapestStorePriceB = cheapestStorePriceForProduct(itemBProduct);

        return parseFloat(cheapestStorePriceB) - parseFloat(cheapestStorePriceA);
    });
};

export const filtrandoPeloSlider = (min, max, produtosDisponiveis) => {
    return produtosDisponiveis.filter((produto) => {
        const preco = parseFloat(cheapestStorePriceForProduct(produto));
        return preco >= min && preco <= max;
    });
};
